export class UserTwoFactorLogin {
  AuthenticationId: string;
  AuthenticationCode: string;
  TwoFactorSetupEnabled: boolean;

  constructor(authenticationId: string, authenticationCode: string = "", twoFactorSetupEnabled: boolean = false,) {
    this.AuthenticationId = authenticationId;
    this.AuthenticationCode = authenticationCode;
    this.TwoFactorSetupEnabled = twoFactorSetupEnabled;
  }
}
